// extracted by mini-css-extract-plugin
export default {"metaData":"metaData--la8g6","left":"left--XHW_r","right":"right--OPNvI","xSplit":"xSplit--Z9Qcz","sectionPadding":"sectionPadding--BfteK"};